import React, { useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import { CheckCircle } from 'react-bootstrap-icons';

const ConfirmRegister = (props) => {
  let navigate = useNavigate();  

  return (
    <Container>
      <Row>
        <Col>
          <h2 style={{color: "#009900"}}><CheckCircle /> Registration Successful</h2>
        </Col>
      </Row>
      <Row>
        <Col>
        Thank you for Registering with Ignite Gear.
        </Col>
      </Row>
      <Row>
        <Col>
        {props.new && (
            <p>
                Your registration is complete.  Please check your email for a confirmation link.
            </p>
         )}
         {!props.new && (
            <p>
                Your registration is complete.  You may now login to the site.<br/><br/>
                <Button onClick={() => navigate("/login")}>Login</Button>
            </p>
         )}
        </Col>
      </Row>
    </Container>
  );
};
export default ConfirmRegister;